

export const InfoMessage = ({ message }) => {
    return (
        <div className="custom-toast-message info-message">
            <p>{message}</p>
        </div>
    )

}


export const SuccessMessage = ({ message }) => {
    return (
        <div className="custom-toast-message success-message">
            <p>{message}</p>
        </div>
    )

}


export const ErrorMessage = ({ message }) => {
    return (
        <div className="custom-toast-message error-message">
            <p>{message}</p>
        </div>
    )

}